import CommonHeader from '../pages/Head'
import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import ApplyImg from '../images/Apply Now_1.jpg'
import ExistCustomer from '../images/Existing_Customers.jpg'
import CanMoney from '../images/payday-payday-loans-ca-4.jpg'

class HomtContents extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:'',minmax:[],workinghours:[], Costs:'', States:''};				
	}

	componentDidMount() {				
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})	
		axios.post(process.env.REACT_APP_API_ENV+'api/minmaxloans.php')
			.then(result => {				
				this.setState({minmax:result.data})													
			})	
		axios.post(process.env.REACT_APP_API_ENV+'api/hours.php')			
			.then(result => {	
				this.setState({workinghours:result.data});
			})	
		axios.post(process.env.REACT_APP_API_ENV+'api/findOntario.php')			
			.then(result => {	
				this.setState({Costs:result.data[2]});
				this.setState({States:result.data[1]});
			})	
	}
	render() {		
		return(
			<div>
				<CommonHeader titles="Payday Loan Employment"/>				
				<h1 style={{textAlign:"center",color:"green"}}><small>Employment Opportunity</small></h1>				
				
				<div id="bottom"><br/>					
					<label style={{color:"grey"}}>We respect and reward our employees who initiate and embrace changes while delivering excellent customer services<br/><br/>
						Our employees have made significant contributions, commitment and dedication to the company by their proactive effort, open-mind communication and excellent team-work in a dynamic and challenging environment<br/><br/>
						If you have call center or retail banking experience, once you are ready, please send your resume and cover letter to <strong>careers@cash2u.ca</strong><br/><br/>
						Your interest in our company is appreciated
					</label>
				</div>								
			</div>
		)
	}
}

export default HomtContents